import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const calcPerpetualRentMonthly = (total: number): number => {
	if (total <= 0) return 0;
	return Math.round((total * GOAL_REAL_YIELD) / 12);
};
